// packages block
import { useState } from 'react';

// components block
import Checkbox from '../../../components/Checkbox';
import CustomButton from '../../../components/layout/CustomButton';
import CandidateSearchItem from './CandidateSearchItem';

// interfaces, graphql, constants block
import InputField from '../../../components/layout/InputField';
import NoDataFound from '../../../components/layout/NoDataFound';
import Pagination from '../../../components/layout/Pagination';
import {
  CLEAR_SELECTION,
  MOVE_TO_FOLDER,
  RECORDS_SELECTED,
  SELECT_All,
} from '../../../constants';
import { PAGE_LIMIT } from '../../../utils/constant';
import CandidateRecruiterModal from './CandidateRecruiterModal';
import { Col, Row } from 'reactstrap';

const CandidateSearchList = ({
  data,
  limit,
  setLimit,
  currentPage,
  setCurrentPage,
  jobOrderId,
  refetch,
  type
}) => {
  const [recruiterFolder, setRecruiterFolder] = useState<boolean>(false);
  const [selectedCandidates, setSelectedCandidates] = useState<any[]>([]);
  const [allSelected, setAllSelected] = useState<boolean>(false);

  const recruiterFolderToggle = () => setRecruiterFolder(!recruiterFolder);

  const manageAllSelection = (e: any) => {
    if (e.target.checked) {
      setSelectedCandidates(candidates);
      setAllSelected(true);
    } else {
      setSelectedCandidates([]);
      setAllSelected(false);
    }
  };

  const count = data?.allCandidatesAdvanceSearch?.count || data?.candidatesSearchDev?.count
  const candidates = data?.allCandidatesAdvanceSearch?.candidates || data?.candidatesSearchDev?.candidates
  const geoLocDistance = data?.allCandidatesAdvanceSearch?.geoLocDiffs || data?.candidatesSearchDev?.geoLocDiffs

  return (
    <>
      {candidates?.length ? (
        <>
          <div className="py-3 px-4">
            <div className="candidate-search-top d-flex flex-wrap align-items-center justify-content-between w-100">
              <div className="d-flex candidate-search-all">
                <Checkbox
                  parentClass="checkbox-square"
                  selectedCandidates={selectedCandidates}
                  allSelected={allSelected}
                  onChange={(e: any) => manageAllSelection(e)}
                />

                <p className="pt-1">{SELECT_All}</p>
              </div>

              <div className="candidate-search-option flex-wrap d-flex align-items-center gap-10">
                <p className="mb-0 mr-2">
                  {selectedCandidates?.length} {RECORDS_SELECTED}
                </p>
                <CustomButton
                  buttonText={CLEAR_SELECTION}
                  buttonColor="primary"
                  buttonType="button"
                  className="graydark-button"
                  buttonClick={() => {
                    setSelectedCandidates([]);
                    setAllSelected(false);
                  }}
                />{' '}
                <CustomButton
                  buttonText={MOVE_TO_FOLDER}
                  buttonColor="primary"
                  buttonType="button"
                  buttonClick={() =>
                    selectedCandidates?.length && setRecruiterFolder(true)
                  }
                />{' '}
              </div>
            </div>

            <div className="mt-4">
              <div className="candidate-search-itemsList">
                {data &&
                  candidates?.map((candidate, index) => {
                    const geoLoc = geoLocDistance ? geoLocDistance[index] : undefined;
                    return (
                      <CandidateSearchItem
                        jobOrderId={jobOrderId}
                        type={type}
                        refetch={refetch}
                        candidate={candidate}
                        geoLocDistance={geoLoc}
                        selectedCandidates={selectedCandidates}
                        setSelectedCandidates={setSelectedCandidates}
                        setAllSelected={setAllSelected}
                        key={index}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
          {candidates?.length ? (
            <div className="users-pagination">
              <Pagination
                onPageChange={(pageClicked: number) => {
                  setCurrentPage(pageClicked);
                }}
                pageCount={Math.ceil(count / limit)}
                currentPage={currentPage}
              />

              <div className="d-flex align-items-center">
                <div className="pagination-display paginationItemsSelect">
                  <p className="m-0">
                    {(currentPage - 1) * limit + 1} to{' '}
                    {Math.min(currentPage * limit, count)} of {count}
                  </p>

                  <div className="divider"></div>
                  <label>Display</label>
                  <InputField
                    label=""
                    inputtype="select"
                    selectItems={PAGE_LIMIT.filter(
                      (item) => item.value !== limit
                    )}
                    inputid="limit"
                    placeholder={limit.toString()}
                    inputMethod={(value: string) => {
                      setCurrentPage(1);
                      setLimit(parseInt(value));
                    }}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <div className="candidate-serach-wrap h-100">
          <NoDataFound text="No Candidates found" />
        </div>
      )}
      <CandidateRecruiterModal
        isOpen={recruiterFolder}
        toggle={recruiterFolderToggle}
        recordToAdd={selectedCandidates?.map((candidate: any) => candidate?.id)}
        refetch={() => console.log('Refetching candidates')}
        clearRecord={() => console.log('Clearing record')}
      />
    </>
  );
};

export default CandidateSearchList;
